import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';

export default function ConstructionServices() {
  return (
    <div className="min-h-screen" dir="rtl">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-4">
          <nav className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-[#E71B25] transition-colors">
              الرئيسية
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <Link to="/services" className="hover:text-[#E71B25] transition-colors">
              الخدمات
            </Link>
            <i className="ri-arrow-left-s-line mx-2"></i>
            <span className="text-[#595A5C] font-medium">الإنشاءات والطرق</span>
          </nav>
        </div>
      </div>

      <main className="py-20">
        <div className="container mx-auto px-4">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-[#595A5C] mb-6">الإنشاءات والطرق</h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              نختص في تنفيذ مشاريع البنية التحتية والطرق بأعلى معايير الجودة والكفاءة، 
              من التسوية والحفر وصولاً إلى الشبكات المتكاملة والإنارة الذكية
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-20">
            {/* Service Image */}
            <div className="order-2 lg:order-1">
              <img
                src="https://public.readdy.ai/ai/img_res/eb5db8bb7bbbeea3cab2aa278a005b68.jpg"
                alt="الإنشاءات والطرق"
                className="w-full h-96 object-cover rounded-2xl shadow-lg"
              />
            </div>

            {/* Service Content */}
            <div className="order-1 lg:order-2">
              <h2 className="text-3xl font-bold text-[#595A5C] mb-8">نطاق خدماتنا</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">أعمال التسوية والحفر</h3>
                    <p className="text-gray-600">تسوية الأراضي وأعمال الحفر بالمعدات الثقيلة المتطورة</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">طبقات الأساس والخرسانة</h3>
                    <p className="text-gray-600">إنشاء طبقات الأساس وصب الخرسانة وفق المواصفات الدولية</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">رصف الأسفلت والأرصفة</h3>
                    <p className="text-gray-600">رصف الطرق بالأسفلت عالي الجودة وتنفيذ الأرصفة والإنترلوك</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">الكهرباء والإنارة</h3>
                    <p className="text-gray-600">تمديدات الكهرباء وأنظمة الإنارة الذكية للطرق والمرافق</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-6 h-6 bg-[#E71B25] rounded-full flex items-center justify-center ml-4 mt-1 flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-[#595A5C] mb-2">شبكات المياه والصرف</h3>
                    <p className="text-gray-600">تنفيذ شبكات المياه والصرف الصحي وأنظمة الاتصالات</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Standards Section */}
          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-8 text-center">معايير الامتثال والجودة</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">المواصفات الكويتية</h3>
                <p className="text-gray-600">الالتزام الكامل بالمواصفات والمعايير الكويتية للطرق</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-list-3-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">ضمان الجودة QA/QC</h3>
                <p className="text-gray-600">أنظمة مراقبة الجودة المتقدمة والتوثيق الشامل</p>
              </div>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-[#E71B25] rounded-xl flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-white text-2xl"></i>
                </div>
                <h3 className="font-semibold text-[#595A5C] mb-2">الالتزام بالمواعيد</h3>
                <p className="text-gray-600">تسليم المشاريع في الوقت المحدد بدون تأخير</p>
              </div>
            </div>
          </div>

          {/* Why Choose Us */}
          <div className="mb-20">
            <h2 className="text-3xl font-bold text-[#595A5C] mb-12 text-center">لماذا فيبا للتجارة؟</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-tools-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">خبرة تقنية متقدمة</h3>
                <p className="text-gray-600">فريق من المهندسين والفنيين المتخصصين بخبرة واسعة في مشاريع البنية التحتية</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-award-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">سجل حافل بالإنجازات</h3>
                <p className="text-gray-600">تنفيذ مئات المشاريع بنجاح في دولة الكويت والمنطقة الخليجية</p>
              </div>
              
              <div className="text-center bg-white p-8 rounded-2xl shadow-lg">
                <div className="w-20 h-20 bg-[#E71B25] rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-customer-service-2-line text-white text-3xl"></i>
                </div>
                <h3 className="text-xl font-bold text-[#595A5C] mb-4">دعم شامل ومتابعة</h3>
                <p className="text-gray-600">خدمة عملاء متميزة ومتابعة مستمرة من بداية المشروع حتى التسليم النهائي</p>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="text-center bg-[#E71B25] text-white p-12 rounded-2xl">
            <h2 className="text-3xl font-bold mb-6">مستعد لبدء مشروعك؟</h2>
            <p className="text-xl mb-8 opacity-90">
              تواصل معنا اليوم للحصول على عرض سعر مخصص لمشروع الإنشاءات والطرق الخاص بك
            </p>
            <Button 
              variant="outline" 
              size="lg" 
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#E71B25] whitespace-nowrap"
              onClick={() => window.location.href = 'mailto:info@vipatradingco.com'}
            >
              طلب عرض سعر
              <i className="ri-mail-line mr-2"></i>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}